const NoScheduledEventsBox = () => {
  return <div style={{
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '24px',
    border: '2px dashed #d9d9d9',
    borderRadius: '8px',
  }}>
    <div style={{
      textAlign: 'center',
      color: '#8c8c8c',
      fontSize: '16px'
    }}>
      No Scheduled Events
    </div>
  </div>
}

export default NoScheduledEventsBox